import { ROLES } from "../utils/roles";

const VALID_ROLES = new Set(Object.values(ROLES));

export function clearSession() {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("currentUser");
}

function decodeTokenPayload(token) {
  try {
    const encoded = token.split(".")[1];
    if (!encoded) return null;
    const normalized = encoded.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(
      normalized.length + ((4 - (normalized.length % 4)) % 4),
      "=",
    );
    return JSON.parse(atob(padded));
  } catch (_error) {
    return null;
  }
}

export function readSession() {
  const token = sessionStorage.getItem("token");
  const rawUser = sessionStorage.getItem("currentUser");
  if (!token || !rawUser) {
    clearSession();
    return null;
  }

  try {
    const user = JSON.parse(rawUser);
    const claims = decodeTokenPayload(token);
    const valid =
      claims &&
      Number(claims.exp) * 1000 > Date.now() &&
      typeof user?.email === "string" &&
      VALID_ROLES.has(user?.role) &&
      claims.email === user.email &&
      claims.role === user.role;
    if (!valid) throw new Error("Invalid session");
    return { token, user };
  } catch (_error) {
    clearSession();
    return null;
  }
}

export function saveSession(token, user) {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("currentUser", JSON.stringify(user));
}

export function getAccessToken() {
  return readSession()?.token || null;
}
